import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { SharedResourcesRequest } from '../interfaces/shared.interface';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SharedService {

    constructor(private http: HttpClient) {
    }

    createShare(request: SharedResourcesRequest) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<any>(`${environment.apiUrls.coreApi}/shared-resources`, request, { headers });
    }

    /**
     * Busca compartilhamentos com paginação para uso em TreeView com lazy loading
     */
    getShareds(params: {
        page: number;
        limit: number;
    }): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const httpParams = new HttpParams()
            .set('page', params.page.toString())
            .set('limit', params.limit.toString());

        return this.http.get<any>(`${environment.apiUrls.coreApi}/shared-resources/me`, { params: httpParams, headers });
    }

    /**
     * Busca compartilhamento pelo id.
     */
    getShared(sharedId: string): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.get<any>(`${environment.apiUrls.coreApi}/shared-resources/${sharedId}`, { headers }).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === HttpStatusCode.NotFound) {
                    return of({ shared_with: [] });
                }
                return throwError(() => error);
            })
        );
    }

    /**
     * Excluir compartilhamento
     */
    delete(sharedId: string): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.delete<any>(`${environment.apiUrls.coreApi}/shared-resources/${sharedId}`, { headers });
    }
}
